/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Reopen_TitleInputs */

const vi_einvoice_reopen_title = /** @type {(inputs: Einvoice_Reopen_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở lại đơn này?`)
};

/**

* @param {Einvoice_Reopen_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reopen_title = /** @type {((inputs?: Einvoice_Reopen_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Reopen_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reopen_title(inputs)
});